/**
 * This core file is for working on the core components 
 * of the theme.
 * 
 * It's unlikely you would need to alter this file
 */
import CookieNotice from '../inc/cookie'


/**
 * Load core components
 */
CookieNotice()
